<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>我的信息</p>
    </div>
    <div class="panel-content center_content">
      <div class="person clearfix">
        <div class="head">
          <div class="userhead">
            <img
              :src="this.$store.state.userInfo.avatar?this.$store.state.userInfo.avatar:'-'"
              :onerror="$store.state.defaultHeadImg"
            >
          </div>

          <div
            class="upload"
            id="uploadimg"
            @click="showUpdateImageWindow"
          >修改头像</div>
        </div>
        <ul id="elList">
          <li>
            <div class="info">姓名：<span>{{name}}</span>
              <a
                href="javascript:;"
                class="change-email"
                @click="showUpdateNameWindow"
              >修改</a>
            </div>
          </li>
          <li>
            <div class="info">账号：<span>{{$store.state.userInfo.user_name}}</span></div>
          </li>
          <li>
            <div class="info">身份：<span>{{roleFormater(role)?roleFormater(role):'--'}}</span></div>
          </li>
          <li>
            <div class="info">性别：<span>{{$store.state.userInfo.gender==1?'男': '女'}}</span>
              <a
                href="javascript:;"
                class="change-email"
                @click="showUpdateGenderWindow"
              >修改</a>
            </div>
          </li>
          <li>
            <div class="info">手机号：<span>{{$store.state.userInfo.mobile?$store.state.userInfo.mobile.substr(0, 3) + '****' + $store.state.userInfo.mobile.substr(7):'--'}}</span>
              <a
                href="javascript:;"
                class="change-phone"
                @click="showUpdateMobileWindow"
              >变更绑定手机号</a>
            </div>
          </li>
          <li>
            <div class="info">院系：<span>{{academy?academy:'--'}}</span></div>
          </li>
          <li>
            <div class="info">专业：<span>{{major?major:'--'}}</span></div>
          </li>
          <li>
            <div class="info">学号：<span>{{s_no?s_no:'--'}}</span></div>
          </li>
        </ul>
      </div>
    </div>

    <div
      class="form_overlay"
      id="form_overlay"
      :style="classShowUpdateGender"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">修改性别</div>
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <span class="label"><i class="require">*</i>性别</span>
              <div class="k-container clearfix">
                <label class="check-label">
                  <input
                    type="radio"
                    v-model="gender"
                    :value="1"
                    checked
                  >男</label>
                <label class="check-label">
                  <input
                    type="radio"
                    v-model="gender"
                    :value="0"
                  >女</label>
              </div>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="form_close"
            @click="hideUpdateGenderWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="form_submit"
            @click="confirmSaveSex"
          >保存</a>
        </div>
      </div>
    </div>

    <div
      class="form_overlay"
      id="name_overlay"
      :style="classShowUpdateName"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">修改姓名</div>
        <div class="form_content">
          <form id="nameForm">
            <div class="item">
              <span class="label"><i class="require">*</i>姓名</span>
              <input
                type="text"
                class="form-control"
                autocompelte="off"
                v-model="nameModify"
                maxlength="10"
              >
            </div>
            <div class="txt-tip">限2-10个中文汉字或4-20位字母</div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="name_close"
            @click="hideUpdateNameWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="name_submit"
            @click="confirmSaveName"
          >保存</a>
        </div>
      </div>
    </div>

    <div
      class="form_overlay"
      id="phone_overlay"
      :style="classShowUpdateMobile"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">变更绑定手机号</div>
        <div class="form_content">
          <form
            class="login_form"
            id="regForm"
          >
            <div class="login_item">
              <input
                class="ipt"
                type="text"
                v-model="changePhoneINfo.mobile"
                placeholder="手机号"
                required=""
                autocomplete="off"
                maxlength="11"
              >
            </div>
            <div class="login_item item-verify">
              <input
                v-model="verifyCode.code"
                class="ipt verify"
                type="text"
                autocomplete="off"
                placeholder="输入图形验证码"
                required=""
              >
              <span
                @click="getVerifyCode"
                class="verify-code"
                title="看不清，换一个"
              ><img :src="formatImage(verify.path)"></span>
            </div>
            <div class="login_item item-verify">
              <input
                v-model="changePhoneINfo.mobile_code"
                class="ipt verify"
                type="text"
                autocomplete="off"
                placeholder="输入短信验证码"
                required=""
              >
              <span
                class="code"
                @click="sendMsg"
                :style="isMsgSend ? 'background:#ccc' : ''"
              >
                {{ this.isMsgSend ? '' + this.seconds + '秒' : '获取验证码' }}
              </span>
            </div>

          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="phone_close"
            @click="hideUpdateMobileWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="phone_submit"
            @click="confirmSaveMobile"
          >保存</a>
        </div>
      </div>
    </div>
    <div
      id="dialog_overlay"
      :style="classShowUpdateImage"
      class=""
    >
      <div id="dialog_bg"></div>
      <div
        id="dialog_panel"
        class=""
        style="margin-left: -311px; margin-top: -192px;"
      >
        <div id="dialog_panel_bg"></div>
        <div id="dialog_title">选择图片</div>
        <div id="dialog_content">
          <div class="imageSelector clearfix">
            <div id="thumbPreview"><img
                src="../../../assets/images/user.png"
                ref="headImg"
              ></div>
            <div class="image-file-content">
              <span
                class="image-file-btn"
                style="display:inline-block"
              >
                <span
                  class="image-file-txt"
                  style="display:none;"
                >选择图片</span>
                <input
                  id="imageFile"
                  type="file"
                  accept="image/*"
                  ref="imageFile"
                  @change="imageFileChange"
                >
              </span>
              <div
                class="image-file-tip"
                style="padding: 10px 0px; font-size: 13px; color: rgb(153, 153, 153);"
              >
                推荐图片尺寸：200px*200px，JPG/PNG格式。图片大小在100KB以内。
              </div>
              <div
                class="image-file-error"
                style="display:none;padding:10px 0;font-size:13px;color:#ff0000;"
              ></div>
            </div>
          </div>
        </div>
        <div id="dialog_control">
          <a
            href="javascript:void(0)"
            @click="hideUpdateImageWindow"
            id="dialog_close"
            class="button"
            style="display: inline-block;"
          >取消</a>
          <a
            href="javascript:void(0)"
            @click="confirmHeadImage"
            id="dialog_ok"
            class="button"
            style="display: inline-block;"
          >确认</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { uuid } from 'vue-uuid'
export default {
  name: 'Profile',
  data() {
    return {
      client_id: '',
      classShowUpdateName: {},
      classShowUpdateImage: {},
      classShowUpdateGender: {},
      classShowUpdateMobile: {},
      name: this.$store.state.userInfo.name,
      gender: this.$store.state.userInfo.gender,
      changePhoneINfo: {
        mobile: this.$store.state.userInfo.mobile,
        mobile_code: ''
      },
      s_no: '',
      role: '',
      academy: '',
      major: '',
      nameModify: '',
      smsVerifyCode: '',
      isMsgSend: false,
      interval: null,
      seconds: 0,
      verifyCode: {
        code: '',
        smsCode: ''
      },
      verify: {
        path: '',
        code: '',
        show: false
      }
    }
  },
  methods: {
    roleFormater(role) {
      if (role === '0' || role === '') {
        return '系统管理员'
      }
      return this.$store.state.dict_role[role]
    },
    // 显示修改姓名弹窗
    showUpdateNameWindow() {
      this.nameModify = this.name
      this.classShowUpdateName = {
        visibility: 'visible'
      }
    },
    hideUpdateNameWindow() {
      this.classShowUpdateName = {}
    },
    // 显示修改性别弹窗
    showUpdateGenderWindow() {
      this.classShowUpdateGender = {
        visibility: 'visible'
      }
    },
    hideUpdateGenderWindow() {
      this.gender = this.$store.state.userInfo.gender
      this.classShowUpdateGender = {}
    },
    // 显示修改手机号弹窗
    showUpdateMobileWindow() {
      this.classShowUpdateMobile = {
        visibility: 'visible'
      }
    },
    hideUpdateMobileWindow() {
      this.changePhoneINfo.mobile = this.$store.state.userInfo.mobile
      this.classShowUpdateMobile = {}
    },
    // 显示修改头像弹窗
    showUpdateImageWindow() {
      this.classShowUpdateImage = {
        visibility: 'visible'
      }
    },
    hideUpdateImageWindow() {
      this.classShowUpdateImage = {}
    },
    // 上传图片
    async imageFileChange() {
      const uploadUrl = '/files/' + this.$refs.imageFile.files[0].name
      await this.$http.put(uploadUrl, this.$refs.imageFile.files[0]).then((data) => {
        this.uploaded_img = data
        this.$refs.headImg.src = data
      }).catch(() => {
        alert('上传失败')
      })
    },
    // 保存图片
    async confirmHeadImage() {
      const url = '/userprofile/' + this.$store.state.userInfo.profile_id + '/'
      await this.$http.put(url, {
        avatar: this.uploaded_img
      }).then((data) => {
        const userInfo = JSON.parse(JSON.stringify(this.$store.state.userInfo))
        userInfo.avatar = this.uploaded_img
        this.$store.commit('setUserInfo', userInfo)
        this.hideUpdateImageWindow()
      }).catch((error) => {
        console.log(error)
        alert('修改失败！')
      })
    },
    // 保存姓名
    async confirmSaveName() {
      if (this.nameModify.trim() === '') {
        this.$parent.showMsg('请输入姓名')
        return false
      }

      if (this.nameModify.length < 2) {
        this.$parent.showMsg('姓名长度必须大于2')
        return false
      }

      if (this.nameModify.length > 20) {
        this.$parent.showMsg('姓名过长')
        return false
      }

      const url = '/userprofile/' + this.$store.state.userInfo.profile_id + '/'
      await this.$http.put(url, {
        name: this.nameModify
      }).then((data) => {
        this.name = this.nameModify
        const userInfo = JSON.parse(JSON.stringify(this.$store.state.userInfo))
        userInfo.name = this.nameModify
        this.$store.commit('setUserInfo', userInfo)
        this.$parent.showMsg('修改成功！')
        this.hideUpdateNameWindow()
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('修改失败！')
      })
    },
    // 保存性别
    async confirmSaveSex() {
      const url = '/userprofile/' + this.$store.state.userInfo.profile_id + '/'
      await this.$http.put(url, {
        gender: this.gender
      }).then((data) => {
        const userInfo = JSON.parse(JSON.stringify(this.$store.state.userInfo))
        userInfo.gender = this.gender
        this.$store.commit('setUserInfo', userInfo)
        this.$parent.showMsg('修改成功！')
        this.hideUpdateGenderWindow()
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('修改失败！')
      })
    },
    // 保存手机号
    async confirmSaveMobile() {
      var mobile = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (!this.changePhoneINfo.mobile) {
        this.$layer.msg('手机号不能为空！')
        return
      } else if (!mobile.test(this.changePhoneINfo.mobile)) {
        this.$layer.msg('手机号格式有误！')
        return
      } else if (this.verify.show && !this.verifyCode.code) {
        this.$layer.msg('请输入图形验证码！')
        return
      } else if (!this.changePhoneINfo.mobile_code) {
        this.$layer.msg('请输入短信验证码！')
        return
      }
      await this.$http.post('/bind_phone/', {
        client_id: this.client_id,
        profile_id: this.$store.state.userInfo.profile_id,
        mobile: this.changePhoneINfo.mobile,
        mobile_code: this.changePhoneINfo.mobile_code,
        code: this.verifyCode.code
      }).then((data) => {
        if (data.code === '200') {
          this.$layer.msg('变更手机号成功')
          const userInfo = JSON.parse(JSON.stringify(this.$store.state.userInfo))
          userInfo.mobile = this.changePhoneINfo.mobile
          this.$store.commit('setUserInfo', userInfo)
          this.hideUpdateMobileWindow()
        } else {
          this.$layer.msg('变更手机号失败')
        }
      }).catch((error) => {
        this.$layer.msg('变更手机号失败！')
        console.dir(error)
      })
    },
    async getUserInfo() {
      const url = '/userprofile/' + this.$store.state.userInfo.profile_id + '/'
      await this.$http.get(url).then((data) => {
        this.s_no = data.s_no
        this.role = data.role
        const userInfo = JSON.parse(JSON.stringify(this.$store.state.userInfo))
        if (data.academy_id) {
          this.searchAcademy(data.academy.id)
          userInfo.academy_id = data.academy.id
          this.$store.commit('setUserInfo', userInfo)
        }
        if (data.major_id) {
          this.searchMajor(data.major.id)
        }
      })
    },
    async searchAcademy(id) {
      const url = '/academy/' + id + '/'
      await this.$http.get(url).then((data) => {
        const userInfo = JSON.parse(JSON.stringify(this.$store.state.userInfo))
        userInfo.academy_name = data.title
        this.$store.commit('setUserInfo', userInfo)
        this.academy = data.title
      }).catch((error) => {
        console.log(error)
      })
    },
    async searchMajor(id) {
      const url = '/major/' + id + '/'
      await this.$http.get(url).then((data) => {
        this.major = data.title
      }).catch((error) => {
        console.log(error)
      })
    },
    formatImage (path) {
      return this.$store.state.rootUrl + path
    },
    async sendMsg() {
      var mobile = /^1[3456789]\d{9}$/ // 手机号

      if (this.isMsgSend === true) {
        return
      } else if (!this.changePhoneINfo.mobile) {
        this.$layer.msg('手机号不能为空！')
        return
      } else if (!mobile.test(this.changePhoneINfo.mobile)) {
        this.$layer.msg('手机号格式有误！')
        return
      } else if (this.changePhoneINfo.mobile === this.$store.state.userInfo.mobile) {
        this.$layer.msg('要变更的手机号不能与当前的一致')
        return
      }
      const checkData = await this.$http.get('/userprofile/', {
        params: {
          eq_mobile: this.changePhoneINfo.mobile
        }
      })
      if (checkData.results.length) {
        this.$layer.msg('手机号已被绑定，请重新输入！')
        return
      }
      await this.$http.get('/send_mobile/', {
        params: {
          client_id: this.client_id,
          mobile: this.changePhoneINfo.mobile,
          template: 'SMS_238150786'
        }
      }).then((data) => {
        this.$layer.msg('验证码已发送，有效期两分钟！')
        this.isMsgSend = true
        this.seconds = 120
        this.interval = setInterval(() => {
          if (this.seconds === 0) {
            clearInterval(this.interval)
            this.isMsgSend = false
          }
          this.seconds -= 1
        }, 1000)
      }).catch(() => {
        this.$parent.showMsg('发送验证码失败！')
      })
    },
    async getVerifyCode() {
      await this.$http.get('/login_code/', {
        params: {
          client_id: this.client_id
        }
      }).then(async (data) => {
        this.verify.path = data.path
        this.verify.show = true
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  mounted() {
    this.client_id = uuid.v1()
    this.getUserInfo()
    this.getVerifyCode()
  }
}
</script>

<style scoped>
@import "../../../assets/css/my-profile.css";

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
  vertical-align: baseline;
}
#phoneForm {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
#phoneForm .item {
  display: flex;
  justify-content: center;
  align-items: center;
}
.code {
  background: #73D6CA;
  display: inline-block;
  width: 120px;
  height: 50px;
  color: #fff;
  line-height: 50px;
  text-align: center;
  cursor: pointer;
}
.item-verify {
  display: flex;
}
.verify {
  flex: 1;
}
</style>
